<template>
  <div style="display:none"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'PhotoProcessingManager',
  
  props: {
    photoIds: {
      type: Array as () => number[],
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      processingInterval: null as number | null,
      processingTimeout: null as number | null,
      isProcessing: false,
      isMounted: false,
    };
  },

  mounted() {
    this.isMounted = true;
  },

  watch: {
    photoIds: {
      handler(newIds: number[]) {
        if (newIds.length > 0 && this.enabled) {
          this.startProcessing();
        } else {
          this.stopProcessing();
        }
      },
      immediate: true
    },
    
    enabled(newValue: boolean) {
      if (newValue && this.photoIds.length > 0) {
        this.startProcessing();
      } else {
        this.stopProcessing();
      }
    }
  },

  beforeUnmount() {
    this.isMounted = false;
    this.stopProcessing();
  },

  methods: {
    ...mapActions({
      getProcessedPhotos: 'photos/getProcessedPhotos'
    }),

    startProcessing() {
      if (this.processingInterval || this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      
      // Починаємо перевірку через 2 секунди після завантаження
      this.processingTimeout = window.setTimeout(() => {
        this.processingTimeout = null;
        this.checkProcessedPhotos();
      }, 2000);
    },

    stopProcessing() {
      if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
        this.processingTimeout = null;
      }
      if (this.processingInterval) {
        clearInterval(this.processingInterval);
        this.processingInterval = null;
      }
      this.isProcessing = false;
    },

    async checkProcessedPhotos() {
      if (!this.isMounted || !this.photoIds.length || !this.enabled) {
        this.stopProcessing();
        return;
      }

      try {
        // Отримуємо оброблені фотографії
        const processedPhotos = await this.getProcessedPhotos({ photoIds: [...this.photoIds] });
        
        // Перевіряємо, чи всі фотографії оброблені
        if (processedPhotos.length === this.photoIds.length) {
          // Всі фотографії оброблені - зупиняємо перевірку
          this.stopProcessing();
          
          // Емітимо подію про завершення обробки
          this.$emit('processing-complete', this.photoIds);
        } else {
          // Не всі фотографії оброблені - продовжуємо перевірку
          if (!this.processingInterval && this.isMounted) {
            this.processingInterval = window.setInterval(() => {
              if (!this.isMounted) {
                this.stopProcessing();
                return;
              }
              this.checkProcessedPhotos();
            }, 2000);
          }
        }

      } catch (error) {
        console.error('Error checking processed photos:', error);

        if (this.enabled && this.photoIds.length > 0 && this.isMounted) {
          if (!this.processingInterval) {
            this.processingInterval = window.setInterval(() => {
              if (!this.isMounted) {
                this.stopProcessing();
                return;
              }
              this.checkProcessedPhotos();
            }, 2000);
          }
        }
      }
    }
  }
});
</script>
